export default class NoRightsError extends Error {
    constructor(message) {
        super();
        this.message = message;
        this.errorType = 'NoRightsError';
    }
}
//# sourceMappingURL=NoRightsError.js.map